import { Link } from "react-router-dom";

const STEPS = [
  ["01", "Prise de contact",       "Vous nous contactez via le formulaire ou par mail. Nous étudions votre installation et vous proposons un créneau."],
  ["02", "Diagnostic sur site",    "À l'arrivée, nous inspectons les modules : encrassement, micro-fissures, état des cadres et des joints."],
  ["03", "Nettoyage à l'eau pure", "Application d'eau pure osmosée à la perche carbone, sans produit chimique. Aucun poids sur votre toiture."],
  ["04", "Rapport d'intervention", "Vous recevez un rapport avec photos avant/après et préconisations d'entretien sur 12 mois."],
  ["05", "Garantie de résultat",   "Si le rendement nominal n'est pas restauré, nous intervenons à nouveau gratuitement sous 30 jours."],
];

export default function Methode() {
  return (
    <div data-testid="methode-page">
      <section className="section pt-16">
        <div className="container-x max-w-3xl">
          <p className="tag">Notre méthode</p>
          <h1 className="text-[40px] md:text-[52px] leading-[1.1] font-bold text-[#0F1A2A]">
            Un protocole en 5 étapes.
          </h1>
          <p className="mt-6 text-[17px] text-[#1F2A3D]">
            Transparence, traçabilité, garantie de résultat : chaque intervention suit un
            protocole simple et documenté, identique pour les particuliers comme les
            professionnels.
          </p>
        </div>
      </section>

      <section className="section bg-[#F6F4EF] border-t border-[#E6E4DF]">
        <div className="container-x max-w-3xl">
          <ol className="space-y-10">
            {STEPS.map(([n, t, d]) => (
              <li key={n} className="grid grid-cols-[auto_1fr] gap-6">
                <span className="text-[#6B7280] font-mono text-sm pt-1">{n}</span>
                <div>
                  <p className="text-xl font-semibold text-[#0F1A2A]">{t}</p>
                  <p className="text-[#1F2A3D] mt-2">{d}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="section border-t border-[#E6E4DF]">
        <div className="container-x max-w-3xl">
          <p className="tag">Ce qui est inclus</p>
          <h2 className="h-title">À chaque intervention</h2>
          <ul className="mt-8 space-y-3 text-[#1F2A3D]">
            <li>· Rapport photo avant et après</li>
            <li>· Mesure de production sur 7 jours avant et après</li>
            <li>· Préconisations d'entretien sur 12 mois</li>
            <li>· Couverture RC Pro et facture certifiée</li>
          </ul>

          <div className="mt-10">
            <Link to="/contact" data-testid="methode-cta" className="btn btn-primary">
              Demander un diagnostic
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
